import {
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_SECONDARY_COLOR,
} from '@containers/Home/constants';
import { createGlobalStyle } from 'styled-components';

/* istanbul ignore next */
export const ThemeGlobal = createGlobalStyle<{
  primaryColor?: string;
  secondaryColor?: string;
}>`
  :root {
    --color-primary: ${props => props.primaryColor || DEFAULT_PRIMARY_COLOR};
    --color-secondary: ${props =>
      props.secondaryColor || DEFAULT_SECONDARY_COLOR};
  }

`;
